import React from 'react';

import { useCookies } from 'react-cookie';
import { useLocation, useNavigate } from 'react-router-dom';

export const CheckAuth = ({ children }) => {
    const [cookies] = useCookies(['access']);
    const navigate = useNavigate();

    React.useEffect(() => {
        if (cookies.access === undefined) {
            navigate("/");
        }
    }, []);

    return children;
};